import React from 'react'; 
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {Box, IconButton} from "@mui/material";
import {RootState, useAppDispatch, useAppSelector} from "../../../state/state.tsx";
import {closeModal} from "../../../state/ModalSlice/ModalSlice.ts";
import CloseIcon from "@mui/icons-material/Close";
import {getBankAccountImage} from "../utilityFunctions.ts";


export default function ViewAccountDetails() {

    const open = useAppSelector((state: RootState) => state.ModalSlice.ViewAccountDetails)

    const Dispatch = useAppDispatch();

    function handleClose() {
        Dispatch(closeModal("ViewAccountDetails"))
    }

    const AccountNumber: string = useAppSelector((state: RootState) => state.ArbitrarySlice.ForBankModal.accountNumber)
    const IFSCCode: string = useAppSelector((state: RootState) => state.ArbitrarySlice.ForBankModal.IFSCCode)
    const AccountName: string = useAppSelector((state: RootState) => state.ArbitrarySlice.ForBankModal.accountName)

    return (<React.Fragment>

            <Dialog
                sx={{
                    padding: 0,
                    '& .MuiPaper-root': {
                        borderRadius: '16px',
                    },
                }}
                maxWidth="md"
                open={open}
                PaperProps={{
                    component: 'div',

                }}
            >
                <DialogContent sx={{paddingX: "60px", paddingY: "50px"}} className={"bg-white"}>
                    <div className={"header pb-[20px]"}>
                        <p className={"text-cf_heading font-[600] "}>View Bank Details</p>
                    </div>
                    <div className={"absolute right-4 top-4"}><IconButton onClick={handleClose}>
                        <CloseIcon/>
                    </IconButton></div>
                    <div className={""}>
                        <div className={""}>
                            <div className={"flex w-full"}>
                                <div className={"w-[550px]"}>
                                    <Box
                                        component={"div"}
                                        // component="form"
                                        sx={{}}
                                    >

                                        <div
                                            className={"flex gap-4 bg-cc_bg_app p-2 shadow-lg"}>
                                            <div className={"flex justify-center items-center"}><img
                                                className={"size-[70px]"}
                                                src={getBankAccountImage(IFSCCode.substring(0, 4))}
                                                alt={"BANK"}/></div>
                                            <div className={"flex flex-col "}>
                                                <p><span
                                                    className={"font-semibold"}>Name</span> : {AccountName}
                                                </p>
                                                <p><span
                                                    className={"font-semibold"}>Acc</span> : {AccountNumber}
                                                </p>
                                                <p><span
                                                    className={"font-semibold"}>IFSC</span> : {IFSCCode}
                                                </p>
                                            </div>

                                        </div>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"flex gap-2 pt-4 justify-center"}>
                        <button onClick={(e) => {
                            e.preventDefault();
                            handleClose()
                        }}
                                className={"w-[100%] bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg"}>Close
                        </button>
                    </div>
                </DialogContent>

            </Dialog>

        </React.Fragment>
    );
}